import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { resetContext } from 'store/globalState/global';
import { setBreadcrumb } from 'components/Navbar/modules';
import { goHome } from 'modules/steps/actions';
import Gpdr from '../components/Gpdr';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.gpdr,
    color: state.app.color1,
    user: state.session.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    goHome: bindActionCreators(goHome, dispatch),
    resetContext: bindActionCreators(resetContext, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Gpdr),
);



// WEBPACK FOOTER //
// ./src/routes/Gpdr/container/index.js